export enum LocalStorageKey {
  SIGNUP_REF = 'signupRef',
  DOC_LIMIT_BANNER_COUNT = 'doc-limit-banner-count'
}
